import { Component, OnInit, Input } from '@angular/core';
import { activity_status } from '../../core/models/task-status';
import { AppState, ShowRequest } from '../../core';
import { PathTestDoc } from '../../core/schema/path-test-schema';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DriveTestDoc } from '../../core/schema/drive-test-schema';

class PathTestInfo {
  buildingId?: string
  pathId: string
  stage: string
  cycle: number
  testOrder: number
  statusCssClass: string
  type: string
  routeId?: string
}

@Component({
  selector: 'app-path-test-header',
  templateUrl: './path-test-header.component.html',
  styleUrls: ['./path-test-header.component.scss']
})
export class PathTestHeaderComponent implements OnInit {

  pathTestInfo$: Observable<PathTestInfo>

  @Input('pathTestDoc') set taskSetter(pathTestDoc : PathTestDoc | DriveTestDoc){
    this.pathTestInfo$ = pathTestDoc?.$.pipe(
      map( doc => ({
        buildingId: doc.buildingId,
        pathId: doc.pathId,
        routeId: doc.routeId,
        stage: doc.stage,
        cycle: doc.cycle,
        testOrder: doc.order,
        type: doc.type,
        statusCssClass: this.getStatusCssClass(doc.statusId)
      }))
    )
  }

  constructor(public appState : AppState) { }

  ngOnInit(): void {
  }

  getStatusCssClass(statusId:number) : string {
    const statusName = activity_status.Names[statusId]
    switch (statusName) {
      case 'complete': return 'status-complete-text'
      case 'in progress': return 'status-in-progress-text'
      case 'not started': return 'status-not-started-text'
      default: return statusName?.toLowerCase().replace(/\s+/g,'-')
    }
  }

  onShowBuilding(buildingId:string) {
    this.appState.showView.next( new ShowRequest('tab','building', buildingId) )
  }
  onShowRoute(routeId:string) {
    this.appState.showView.next( new ShowRequest('tab','route', routeId) )
  }

  onShowPath(pathId:string, buildingId:string) {
    this.appState.showView.next( new ShowRequest('tab','path', JSON.stringify({ pathId, buildingId })))
  }

  onShowPathTest(taskId:string) {
      this.appState.showView.next( new ShowRequest('tab','path test', taskId) )
  }

}
